import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 路由切换时自动滚动到顶部的 Hook
 *
 * 这个 Hook 监听路由变化，当路由发生变化时会自动将页面滚动到顶部
 * 这样可以确保用户在切换页面时总是从页面顶部开始查看内容
 */
export const useScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    // 当路由发生变化时，滚动到页面顶部
    // 使用 setTimeout 确保在路由切换完成后再执行滚动
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant', // 使用 instant 而不是 smooth，确保立即滚动
      });
    };

    // 使用 setTimeout 延迟执行，确保 DOM 更新完成
    const timer = setTimeout(scrollToTop, 0);

    return () => {
      clearTimeout(timer);
    };
  }, [location.pathname]); // 仅监听路径变化，忽略 hash 和 search 参数
};

/**
 * 路由切换时平滑滚动到顶部的 Hook
 *
 * 提供平滑滚动效果的版本，适用于需要动画效果的场景
 */
export const useScrollToTopSmooth = () => {
  const location = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth', // 平滑滚动动画
      });
    };

    const timer = setTimeout(scrollToTop, 100); // 稍微延迟以确保页面内容加载

    return () => {
      clearTimeout(timer);
    };
  }, [location.pathname]);
};
